import { Component } from '@angular/core';

@Component({
  selector: 'app-edit',
  imports: [],
  template: `<svg
  width="16"
  height="16"
  viewBox="0 0 22 22"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_489_5068)">
    <path
      d="M10.439 4.26045H4.31396C3.84984 4.26045 3.40472 4.44483 3.07653 4.77302C2.74834 5.1012 2.56396 5.54632 2.56396 6.01045V18.2605C2.56396 18.7246 2.74834 19.1697 3.07653 19.4979C3.40472 19.8261 3.84984 20.0105 4.31396 20.0105H16.564C17.0281 20.0105 17.4732 19.8261 17.8014 19.4979C18.1296 19.1697 18.314 18.7246 18.314 18.2605V12.1355M17.0015 2.94795C17.3496 2.59986 17.8217 2.4043 18.314 2.4043C18.8062 2.4043 19.2784 2.59986 19.6265 2.94795C19.9746 3.29605 20.1701 3.76817 20.1701 4.26045C20.1701 4.75274 19.9746 5.22486 19.6265 5.57295L11.314 13.8855L7.81396 14.7605L8.68896 11.2605L17.0015 2.94795Z"
      stroke="#043B22"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <defs>
    <clipPath id="clip0_489_5068">
      <rect
        width="21"
        height="21"
        fill="white"
        transform="translate(0.813965 0.760742)"
      />
    </clipPath>
  </defs>
</svg>
`
})
export class EditComponent {

}
